import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    getProjectById,
    getProjectUserInUseDetail,
    getActiveB2BCustomerListInProjectByProjectId
} from '@/service/projectService';
import {
    updateUserDetail,
    getListUserAddToProject,
    getUserById,
    getUserListInProjectByProjectId,
    createUserProject,
    getCustomerListInProjectByProjectId,
    updateUserResource
} from '@/service/userService';
import {
    createViewData,
    getListViewInProject
} from '@/service/viewService';
import { cloneDeep } from 'lodash';

// get list user can add to prj
export const getListUserCanAddToProject = async args => {
    try {
        const userList = await getListUserAddToProject(
            args.API,
            args.corporationId,
            args.projectDetail
        );

        args.setListUserAddToProject(userList);
    } catch (err) {
        console.log('getListUserCanAddToProject err :>> ', err);
    }
};

export const validateEmailAddUserToProject = (id, userAddList, index) => {
    let errors;
    let email = userAddList.filter(user => user.userDetail.id === id);
    if (email.length > 0) {
        errors = I18n.get('USER09MSG007');
    }
    return errors;
};

export const findMailDuplicate = arr => {
    let valueArr = arr.map(item => item.userDetail.id).filter(item => !!item);
    const mailDuplicate = valueArr.filter((item, idx) => valueArr.indexOf(item) !== idx);
    return mailDuplicate;
};

// Handle select uset to add to prj
export const handleSelectUserAddToProject = async (args, userId, id, userList) => {
    let userAddList = cloneDeep(args.userAddList);
    if (Utils.isEmptyArray(userList)) {
        return;
    }

    const indexAdd = Utils.findIndexInArrayById(userId, userAddList);
    let errorsList = args.errors;
    let errorsRow = errorsList[`${userId}`] ? errorsList[`${userId}`] : {};
    let errors = validateEmailAddUserToProject(id, userAddList, indexAdd);

    if (!Utils.isEmptyString(errors)) {
        errorsRow.mail = errors;
        errorsList[userId] = errorsRow;
        args.setErrors(errorsList);
    } else {
        delete errorsRow.mail;
        errorsList[userId] = errorsRow;
        args.setErrors(errorsList);
    }

    let userDetail = userList.find(user => user.id === id);
    if (!userDetail || Utils.isEmptyObject(userDetail)) {
        return;
    }

    userAddList[indexAdd].userDetail = userDetail;
    
    userAddList[indexAdd].userDetail.privilege = Constant.PROJECT_PERMISSION.MEMBER;
    args.setUserAddList(userAddList);

    let mailDuplicate = findMailDuplicate(userAddList);

    userAddList.forEach(item => {
        if (!mailDuplicate.includes(item.userDetail.id)) {
            delete errorsList[item.id]?.mail;
            args.setErrors(errorsList);
        }
    });
};

export const onChangePermissionForNewUserInProject =  (index, event, args) => {
    let permission = event.target.checked;
    permission = !permission ? Constant.PROJECT_PERMISSION.MEMBER : Constant.PROJECT_PERMISSION.MANAGER;

    let userAddList = cloneDeep(args.userAddList);
    userAddList[index].userDetail.privilege = permission

    args.setUserAddList([...userAddList]);
};

export const onDeleteAddUser = (args, userId) => {
    
    let userAddList = cloneDeep(args.userAddList);
    const findIndex = Utils.findIndexInArrayById(userId, userAddList);
    
    if (Utils.isEmptyObject(userAddList[findIndex].userDetail)) {
        userAddList = userAddList.filter((e, i) => e.id !== userId);
        args.setUserAddList(userAddList);
    } else {
        args.setOpenConfirmModal({ isOpen: true, userId: userAddList[findIndex].id });
    }
};

export const confirmRemoveAddingUser = (argsAll, id) => {
    let userAddList = cloneDeep(argsAll.userAddList);

    const findIndex = Utils.findIndexInArrayById(id, userAddList);
    if (findIndex === -1) return;

    userAddList = userAddList.filter((e, i) => e.id !== id);

    let errorsList = argsAll.errors;
    let mailDuplicate = findMailDuplicate(userAddList);
    userAddList.forEach(item => {
        if (!mailDuplicate.includes(item.userDetail.id)) {
            delete errorsList[item.id]?.mail;
            argsAll.setErrors(errorsList);
        }
    });

    argsAll.setUserAddList(userAddList);
}

export const createViewForUserProject = async (
    API,
    corporationId,
    projectId,
    userId,
    currentUserId
) => {
    // create private view for user
    // get list view by visibility project member in projectInuse
    let listView = await getListViewInProject(
        API,
        projectId,
        projectId,
        Constant.VISIBILITY_SETTING_TYPE.PROJECT
    );
    // listView = Utils.sortByCreatedAtAsc(listView);

    // clone list view to view private of user
    if (!Utils.isEmptyArray(listView)) {
        return Promise.all(
            listView.map((view) => {
                if (view?.structure?.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM) {
                    return view;
                }
                
                let createViewDto = {
                    name: view.name,
                    affiliationOrganization: corporationId,
                    affiliationProject: projectId,
                    affiliationView: view.id,
                    visibleRange: userId,
                    visibleType: Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
                    structure: view.structure,
                    status: view.status,
                    viewType: view.viewType,
                    order: view.order,
                    creator: currentUserId,
                    updator: currentUserId,
                    definitionView: view.definitionView
                };

                return createViewData(API, createViewDto);
            })
        );
    }
};

// get list user of prj
export const getUserList = async args => {
    args.setIsLoading(true);
    getUserListInProjectByProjectId(args.API, args.projectId)
        .then(userList => {
            args.setIsLoading(false);
            let userListInProject = userList?.filter(user => user.type !== Constant.USER_TYPE.CUSTOMER);
            // args.setUserList(userListInProject);
            args.setUserListRecoilValue(userListInProject);
        })
        .catch(err => {
            args.setIsLoading(false);
            args.enqueueSnackbar(I18n.get(err.errors[0].message), {
                variant: 'error',
                autoHideDuration: 3000
            });
        });
};

// get prj detail
export const getProjectDetail = args => {
    args.setIsLoading(true);
    getProjectById(args.API, args.projectId)
        .then(project => {
            args.setIsLoading(false);
            args.setProjectDetail(project);
        })
        .catch(err => {
            args.setIsLoading(false);
            args.enqueueSnackbar(I18n.get(err.errors[0].message), {
                variant: 'error',
                autoHideDuration: 3000
            });
        });
};

export const isDisableBtnSubmit = (
    userChangePermissionProjectList,
    userAddList
) => {

    return (
        (
            Utils.isEmptyArray(userChangePermissionProjectList) &&
            Utils.isEmptyArray(userAddList)) ||
        (!Utils.isEmptyArray(userAddList) && !Utils.isEmptyArray(findMailDuplicate(userAddList))) ||
        (!Utils.isEmptyArray(userAddList) && !Utils.isEmptyArray(userAddList.filter(x => Utils.isEmptyObject(x.userDetail))))
    );
};

export const onClickCancelEdit = (argsAll) => {
    if(isEmptyUserAddList(argsAll) && Utils.isEmptyArray(argsAll.userChangePermissionProjectList)) {
        argsAll.setUserAddList([]);
        return;
    }
    argsAll.setOpenCancelDialog(true);
}

export const isEmptyUserAddList = argsAll => {
    let count = 0;
    let userAddLists = cloneDeep(argsAll.userAddList);
    for (let i = 0; i < userAddLists.length; i++) {
        let user = userAddLists[i];
        if (Utils.isEmptyObject(user.userDetail)) {
            count += 1;
        }
    }
    return count === userAddLists.length;
};

export const onCancelDialog = async args => {
    args.setUserChangePermissionProjectList([]);
    args.setErrors({});

    if(!Utils.isEmptyArray(args.userAddList)) {
        let userAddListClone = cloneDeep(args.userAddList);
        let newUserAddList = [];
        userAddListClone.forEach((userAdd, index) => {
            newUserAddList.push({
                id : Date.now().toString() + index,
                userDetail: {}
            })
        });
        args.setUserAddList(newUserAddList);
    }

    args.setOpenCancelDialog(false);
    await getUserList(args);
}

export const addOneUserToProject = async (args, userId, privilege) => {
    try {
        
        let userProject = {
            projectId: args.projectId,
            usage: Constant.SYSTEM_USAGE_TYPE.PROJECT,
            affiliationOrganization: args.corporationId,
            active: Constant.ACTIVE_FLAG.ACTIVE,
            id2: userId,
            privilege: privilege === Constant.PROJECT_PERMISSION.MANAGER ? Constant.PRIVILEGE_PROJECT.PRJ_MGR : "",
            type: Constant.PROJECT_TYPE.USER_INFO,
            creator: args.userDetail?.id,
            updator: args.userDetail?.id
        };

        const addUserResult = await createUserProject(args.API, userProject);

        if (!addUserResult || !addUserResult.id) {
            return {};
        }

        return addUserResult;
    } catch (error) {
        return {};
    }
};

export const validateAddUserToProject = async (args, userAddList) => {
    // validate userAddList
    let mailDuplicate = findMailDuplicate(userAddList);
    if (!Utils.isEmptyArray(mailDuplicate)) {
        return;
    }

    // get user list lasted
    let userListLasted = await getUserListInProjectByProjectId(args.API, args.projectId);
    let userAddListValid = [];
    let userAddListErrors = [];
    for (let i = 0; i < userAddList.length; i++) {
        let userAdd = userAddList[i];
        if (Utils.findIndexInArrayById(userAdd.userDetail.id, userListLasted) !== -1) {
            userAddListErrors.push(userAdd);
        } else {
            userAddListValid.push(userAdd);
        }
    }

    if(!Utils.isEmptyArray(userAddListErrors)) {
        let errorsList = {};
        userAddListErrors.forEach(userError => {
            errorsList[`${userError.id}`] = {
                mail : 'User exist in project'
            }
        });
        args.setErrors(errorsList);
    }

    if(Utils.isEmptyArray(userAddListValid)) {
        return;
    }

    let listUserAddToProject = userAddListValid.map(useRow => {
        return useRow.userDetail;
    });
    
    return listUserAddToProject;
};

// submit
export const onSubmit = async (
    args,
    userDetail,
    projectInfo,
    isProjectManager,
    userChangePermissionProjectList
) => {
    if (!isProjectManager) {
        return;
    }
    args.setIsLoading(true);

    if (!projectInfo) {
        await cancelSubmitUpdate(args);
    }
    
    let submitParams = {
        corporationId: args.corporationDetail?.id,
        userList: [],
        actionFlag: Constant.USERMANAGEMENT_ACTION_FLAG.ADD_AND_EDIT_USER_IN_PROJECT,
        idOfCurrentUser: args.userDetail?.id,
        projectId: args.projectDetail?.id
    }

    if(!Utils.isEmptyArray(args.userAddList)) {
        let addUserList = await validateAddUserToProject(args, args.userAddList);
        if (!Utils.isEmptyArray(addUserList)) {
            addUserList.forEach(userAdd => {
                submitParams.userList.push({
                    id: userAdd.id,
                    privilege: userAdd.privilege === Constant.PROJECT_PERMISSION.MANAGER ? Constant.PRIVILEGE_PROJECT.PRJ_MGR : '',
                    isAddNew: true,
                    isEdit: false
                });
            })
        }
    }

    let listUserNotIsProjectManager = [];
    let listUserIsProjectManager = [];
    let listUserIdNotIsProjectManager = [];

    if (!Utils.isEmptyArray(userChangePermissionProjectList)) {
        userChangePermissionProjectList.forEach(user => {
            if (
                user.projectDetail.permission === Constant.PROJECT_PERMISSION.MANAGER &&
                !listUserNotIsProjectManager.includes(user.userProjectId)
            ) {
                listUserIsProjectManager.push(user.userProjectId);
                submitParams.userList.push({
                    id: user.id,
                    userProjectId: user.userProjectId,
                    privilege: Constant.PRIVILEGE_PROJECT.PRJ_MGR,
                    isAddNew: false,
                    isEdit: true
                });
            } else {
                submitParams.userList.push({
                    id: user.id,
                    userProjectId: user.userProjectId,
                    privilege: '',
                    isAddNew: false,
                    isEdit: true
                });
                listUserNotIsProjectManager.push(user.userProjectId);
                listUserIdNotIsProjectManager.push(user.id);
            }
        });
    }

    if (Utils.isEmptyArray(submitParams.userList)) {
        await cancelSubmitUpdate(args);
    }
    submitParams.userList = JSON.stringify(submitParams.userList);
    
    let updateProjectUserListResult = await updateUserResource(args.API, submitParams);

    if (updateProjectUserListResult.error) {
        if (updateProjectUserListResult.error === Constant.LIMIT_VALUE_ERROR.MAX_NUM_OF_GENERAL_USER) {
            args.setMessageDialogMaxLimitValue(I18n.get(`${updateProjectUserListResult.error}`));
            args.setIsOpenDialogMaxLimitValue(true);
            args.setIsLoading(false);
            return;
        } else if (
            updateProjectUserListResult.error === Constant.CHANGE_MANAGER_LAST_ERROR &&
            listUserIdNotIsProjectManager.includes(userDetail.id)
        ) {
            listUserIdNotIsProjectManager = listUserIdNotIsProjectManager.filter(
                item => item !== userDetail.id
            );
            args.enqueueSnackbar(I18n.get(`${updateProjectUserListResult.error}`), {
                variant: 'error',
                autoHideDuration: 3000
            });
        } else {
            args.enqueueSnackbar(I18n.get(`${updateProjectUserListResult.error}`), {
                variant: 'error',
                autoHideDuration: 3000
            });
        }
    } else {
        let addUserResult = Utils.convertJSONDataToObject(updateProjectUserListResult.userSuccessList)
        if(!Utils.isEmptyArray(addUserResult)) {
            args.enqueueSnackbar(I18n.get('USER12MSG006'), {
                variant: 'success',
                autoHideDuration: 3000
            });
        }
        else{
            args.enqueueSnackbar(I18n.get('COMMSG047'), {
                variant: 'success',
                autoHideDuration: 3000
            });          
        }
    }

    if (listUserIdNotIsProjectManager.includes(userDetail.id)) {
        args.setIsProjectManager(false);
    }

    await getListUserCanAddToProject(args);
    await getUserList(args);
    // args.setUserListRecoilValue(listUserUpdateResult);
    // args.setUserList(listUserUpdateResult);
    args.setUserAddToProject(null);
    args.setUserChangePermissionProjectList([]);
    args.setUserAddList([]);
    args.setIsLoading(false);

    // If change role user => member: Check panel tab and remove panel ListUserInProject
    let promiseUpdateWorkspace = [];
    listUserIdNotIsProjectManager.forEach(userId => {
        promiseUpdateWorkspace.push(removePanelListUserInProject(args.API, userId, null, args.projectId));
    });
    await Promise.all(promiseUpdateWorkspace);
};

const cancelSubmitUpdate = async args => {
    args.setIsLoading(false);
    args.setUserAddToProject(null);
    args.setUserChangePermissionProjectList([]);
    await getUserList(args);
    await getListUserCanAddToProject(args);
};

export const isDisableBtnDeleteProjectUser = (argsAll) => {
    if (argsAll.projectDetail?.type === Constant.PROJECT_TYPE.BASE || !argsAll.isProjectManager) {
        return true;
    } else {
        return false;
    }
};

export const onChangePermissionForUserInProject = (
    index,
    event,
    userList,
    userChangePermissionProjectList,
    args
) => {
    let permission = event.target.checked;
    permission = !permission ? Constant.PROJECT_PERMISSION.MEMBER : Constant.PROJECT_PERMISSION.MANAGER;

    let tmpUserList = [...userList];
    tmpUserList[index].isChangePermissionProject =
        tmpUserList[index].projectDetail.defaultPermission !== permission ? true : false;

    tmpUserList[index].projectDetail.permission = permission;
    args.setUserList([...tmpUserList]);

    // update list change permission
    if (tmpUserList[index].isChangePermissionProject) {
        args.setUserChangePermissionProjectList(prev => [...prev, tmpUserList[index]]);
    } else {
        let userId = tmpUserList[index].id;
        let newUserChangePermissionProjectList = userChangePermissionProjectList.filter(
            item => item.id !== userId
        );
        args.setUserChangePermissionProjectList(newUserChangePermissionProjectList);
    }
};

export const handleAddNew = async argsAll => {
    if (argsAll.userAddList.length === argsAll.listUserAddToProject.length) {
        return;
    }
    const newUserProject = {};
    newUserProject.id = Date.now().toString();
    newUserProject.userDetail = {};
    argsAll.setUserAddList(prev => [...prev, newUserProject]);
};



/**
 * onClickDeleteProjectUser
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const onClickDeleteProjectUser = async (argsAll, user) => {
    if (Utils.isEmptyObject(user) || !user.id || isDisableBtnDeleteProjectUser(argsAll)) {
        return;
    }
    argsAll.setOpenConfirmModal({ isOpen: true, userId: user.id });
};


export const submitDeleteProjectUser = async (argsAll, userId) => {
    if (!userId) return;
    
    let projectUserList = cloneDeep(argsAll.userList);
    let userDeletedDetail = projectUserList.find(user => user.id === userId);
    if (Utils.isEmptyObject(userDeletedDetail) || !userDeletedDetail.userProjectId) return;

    argsAll.setIsLoading(true);
    // Check is user is removed from project
    let userInfoInProject = await getProjectUserInUseDetail(argsAll.API, userId, argsAll.projectId);
    if (!userInfoInProject || userInfoInProject.active !== Constant.ACTIVE_FLAG.ACTIVE) {
        argsAll.setIsLoading(false);
        argsAll.setIsOpenModalReloadPage(true);
        return;
    }

    // update users amount of corporation
    let deletedUserInProject = {
        deletedUserId: userId,
        corporationId: argsAll.corporationId,
        projectId: argsAll.projectId,
        actionFlag: Constant.USERMANAGEMENT_ACTION_FLAG.DELETE_USER_IN_PROJECT
    };
    let removeProjectUserResult = await updateUserResource(argsAll.API, deletedUserInProject);
    argsAll.setIsLoading(false);
    if (!removeProjectUserResult || !removeProjectUserResult.status) {
        if (removeProjectUserResult?.errorMessage) {
            if (argsAll?.setUpdateUserListError) {
                argsAll?.setUpdateUserListError(removeProjectUserResult?.errorMessage);
            }
            return;
        }

        if (removeProjectUserResult?.error) {
            argsAll?.setUpdateUserListError(I18n.get(removeProjectUserResult?.error));
        } else {
            argsAll.setIsOpenModalReloadPage(true);
        }
        return;
    }
    
    await getUserList(argsAll);
    await getListUserCanAddToProject(argsAll);

    // Get user info and if project inuse is current project, change project inuse to base prj
    const userInfo = await getUserById(argsAll.API, userDeletedDetail.id);
    if (Utils.isEmptyObject(userInfo)) {
        return;
    }

    // If user is opening tab SYSTEM_PROJECT_USER_MANAGEMENT => remove tab
    await removePanelListUserInProject(argsAll.API, userInfo.id, userInfo, argsAll.projectDetail.id);
}

export const checkDisplayTabs = async argsAll => {
    let isDisplayProjectUserTab = await isDisplayTabManagement(
        argsAll,
        Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_USER_PROJECT_LIST
    );
    argsAll.setIsDisplayProjectUserTab(isDisplayProjectUserTab);
    if (isDisplayProjectUserTab) {
        argsAll.setTabSelected(Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_USER_PROJECT_LIST);
        return;
    }
};

export const checkDisplayTabsCustomer = async (argsAll,currentTab) => {
   const isDisplayB2CTab = await isDisplayTabManagement(
        argsAll,
        Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2C_CUSTOMER_MANAGEMENT
    );
    argsAll.setIsDisplayB2CTab(isDisplayB2CTab);

    const isDisplayB2BTab = await isDisplayTabManagement(
        argsAll,
        Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2B_CUSTOMER_MANAGEMENT
    );
    argsAll.setIsDisplayB2BTab(isDisplayB2BTab);

    switch (currentTab) { // switch with currentTab to doesn't auto render to tab1 when call useEffect in 89:ProjectCustomerManager.js
        case Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2C_CUSTOMER_MANAGEMENT:
            if(isDisplayB2CTab)
                argsAll.setTabSelected(
                Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2C_CUSTOMER_MANAGEMENT
            ); 
            return;
        case Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2B_CUSTOMER_MANAGEMENT:
            if(isDisplayB2BTab)
                argsAll.setTabSelected(
                    Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2B_CUSTOMER_MANAGEMENT
                );
            return;
        default:
    }
}

export const isDisplayTabManagement = async (argsAll, tabType) => {
    let projectInuse = argsAll.projectDetail;
    let isAdmin = argsAll.isAdmin;
    let adminMode = argsAll?.adminMode;
    let isProjectManager = argsAll.isProjectManager;

    switch (tabType) {
        case Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_USER_PROJECT_LIST:
            return isDisplayTabProjectUserList(projectInuse, isProjectManager, isAdmin, adminMode);
        case Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2C_CUSTOMER_MANAGEMENT:
            return await isDisplayTabB2CCustomer(projectInuse, isAdmin, isProjectManager, argsAll.API);
        case Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2B_CUSTOMER_MANAGEMENT:
            return await isDisplayTabB2BCustomer(projectInuse, argsAll.API);
        default:
            return false;
    }
};

export const isDisplayTabProjectUserList = (
    projectInuse,
    isProjectManager,
    isAdmin,
    adminMode
) => {
    if (
        projectInuse.type !== Constant.PROJECT_TYPE.BASE &&
        (isProjectManager === true || (isAdmin && adminMode === Constant.ADMIN_MODE.ON))
    ) {
        return true;
    }

    return false;
}

export const isDisplayTabB2CCustomer = async (
    projectInuse,
    isAdmin,
    isProjectManager,
    API
) => {
    if(projectInuse.type === Constant.PROJECT_TYPE.CUSTOMER && isAdmin) {
        return true;
    }

    if (Utils.isPublicDesk(projectInuse)) {
        return true;
    } else {
        let listCustomerInProject = await getCustomerListInProjectByProjectId(API, projectInuse.id);
        if (Utils.isEmptyArray(listCustomerInProject)) return false;

        let listCustomerActive = listCustomerInProject.filter(
            user =>
                user.active === Constant.ACTIVE_FLAG.ACTIVE &&
                user.activeInProject === Constant.ACTIVE_FLAG.ACTIVE
        );

        if (Utils.isEmptyArray(listCustomerActive)) return false;

        return true;
    }
}

export const isDisplayTabB2BCustomer = async (
    projectInuse,
    API
) => {
    if(Utils.isPublicDesk(projectInuse)) {
        return true;
    } else {
        let b2bCustomerActiveList = await getActiveB2BCustomerListInProjectByProjectId(
            API,
            projectInuse.id
        );

        if(Utils.isEmptyArray(b2bCustomerActiveList)) return false;

        return true;
    }
}


/**
 * removePanelListUserInProject
 * if remove/change role user => member: Check panel tab and remove panel ListUserInProject
 * @param {*} API 
 * @param {*} userId 
 * @param {*} userInfo 
 * @param {*} projectId 
 * @returns 
 */
export const removePanelListUserInProject = async (API, userId, userInfo, projectId) => {
    if (!userId) return;

    if (!userInfo || Utils.isEmptyObject(userInfo)) {
        userInfo = await getUserById(API, userId);
    }
    if (Utils.isEmptyObject(userInfo)) return;

    let userWorkSpace = cloneDeep(Utils.convertJSONDataToObject(userInfo.workSpace));
    if (userWorkSpace && userWorkSpace.hasOwnProperty(projectId) && !Utils.isEmptyArray(userWorkSpace[projectId])) {
        let currentProjectPanelList = cloneDeep(userWorkSpace[projectId]);
        let indexPanelSystemManagement = currentProjectPanelList.findIndex(panel => panel.type === Constant.PANEL_TYPE.PROJECT_MANAGEMENT);
        if (indexPanelSystemManagement !== -1 && !Utils.isEmptyArray(currentProjectPanelList[indexPanelSystemManagement].tabList)) {
            let systemManagementTabList = cloneDeep(currentProjectPanelList[indexPanelSystemManagement].tabList);
            let tabUserInProjectIndex = Utils.findIndexInArrayById(Constant.PANEL_TYPE.SYSTEM_PROJECT_USER_MANAGEMENT, systemManagementTabList);
            if (tabUserInProjectIndex !== -1) {
                systemManagementTabList = systemManagementTabList.filter(tab => tab.id !== Constant.PANEL_TYPE.SYSTEM_PROJECT_USER_MANAGEMENT);
                if (Utils.isEmptyArray(systemManagementTabList)) {
                    currentProjectPanelList = currentProjectPanelList.filter(panel => panel.type !== Constant.PANEL_TYPE.PROJECT_MANAGEMENT);
                } else {
                    let currentActiveTab = parseInt(currentProjectPanelList[indexPanelSystemManagement].activeTab);
                    currentProjectPanelList[indexPanelSystemManagement].tabList = systemManagementTabList;
                    currentProjectPanelList[indexPanelSystemManagement].activeTab = currentActiveTab - 1 === -1 ? 0 : currentActiveTab - 1;
                }

                userWorkSpace[projectId] = currentProjectPanelList;
                let objUpdateUserWorkspace = {
                    id: userInfo.id,
                    workSpace: JSON.stringify(userWorkSpace)
                }
                await updateUserDetail(API, userInfo.id, objUpdateUserWorkspace);
            }
        }
    }
}

export const checkUserPermissions = (user) => {
    if (user.projectDetail.permission === Constant.PROJECT_PERMISSION.MEMBER) {
        return false
    }
    return true;
}

export const checkUserPrivilege = (user) => {
    if (user.userDetail.privilege === Constant.PROJECT_PERMISSION.MANAGER) {
        return true
    }
    return false;
}